export const getParticipantName = (store, participantId) => {
  const { person, spouse } = store

  if (participantId === person.id) {
    return person.displayName
  }

  if (spouse && participantId === spouse.id) {
    return spouse.firstName
  }

  return ''
}
